import { api } from "@/lib/api";

// Fire-and-forget product analytics. Never throws, never blocks the UI, and is a
// no-op for signed-out users (the endpoint requires auth and simply 401s, which
// we swallow).
export const track = (event, props = {}) => {
  try {
    api.post("/analytics/event", { event, props }).catch(() => {});
  } catch {
    /* ignore */
  }
};
